import { CustomTable, CustomText } from "components";
import { getLabel } from "models/third/freightways";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { openLoading } from "store/reducers/tools";

export function OrderTable({ data = {} }) {
  const history = useNavigate();
  const [file, setFile] = useState("");

  const handleClickConsignment = async (row) => {
    try {
      openLoading(true);
      const fileURL = await getLabel({
        trackingInfo: row?.trackingInfo ?? {},
        postCode: row?.address?.postCode,
      });
      setFile(fileURL);
    } catch (error) {
      console.log(error);
      openLoading(false);
    }
  };

  const handleClickRow = (row, index) => {
    history("/order-overview", { state: index });
  };

  useEffect(() => {
    if (file) {
      setTimeout(() => {
        window.frames["printf"].focus();
        window.frames["printf"].print();
        openLoading(false);
      }, 1000);
    }
    // eslint-disable-next-line
  }, [file]);
  return (
    <div>
      <CustomTable
        data={data}
        size="normal"
        columns={[
          {
            label: "Order ID",
            selector: "id",
            cell: (row, index) => (
              <span onClick={() => handleClickRow(row, index)} className="text-primary">#{row?.id}</span>
            ),
          },
          {
            label: "Name",
            selector: "name",
            cell: (row, index) => (
              <span onClick={() => handleClickRow(row, index)}>
                {row?.firstName} {row?.lastName}
              </span>
            ),
          },
          {
            label: "Region",
            selector: "region",
            cell: (row, index) => <span onClick={() => handleClickRow(row, index)}>{row?.address?.label ?? ""}</span>,
          },
          {
            label: "Delivery Ticket",
            selector: "",
            cell: (row) => (
              <CustomText
                className="underline text-sm text-primary"
                bold={700}
                onClick={() => handleClickConsignment(row)}
              >
                {row?.trackingInfo?.consignmentId ?? ""}
              </CustomText>
            ),
          },
          {
            label: "status",
            selector: "status",
            cell: (row, index) => (
              <span onClick={() => handleClickRow(row, index)}>
                {Boolean(row?.trackingInfo?.consignmentId)
                  ? "Fulfilled"
                  : "Unfulfilled"}
              </span>
            ),
          },
        ]}
      />
      <iframe
        title="delivery ticket"
        style={{ display: "none" }}
        id="printf"
        src={file}
        name="printf"
      ></iframe>
    </div>
  );
}
